import useApiServices from './useApiServices';
import { globalAdminUrl } from './globalApi';
//
/**
 * @module PartnerServiceService
 * @returns  it return All DataSource Apis
 */

const globalService = {
  // common apis
  AccessLevel: (credential, token) =>
    useApiServices().postApi(`${globalAdminUrl}/v1/access-level/configs`, credential, token),

  MasterListType: (type, token) =>
    useApiServices().getApi(`${globalAdminUrl}/common/master-list/${type}`, token)
};

export default globalService;
